// extracted by mini-css-extract-plugin
export default {"root":"Messages__root--gL5iN"};